import { ITableHeadCell } from 'components/@shared/TableRemotePagination/types';
import Typography from '@mui/material/Typography';
import getTransformedDate from 'utils/getTransformedDate';
import { InvoiceResponseViewModel } from 'types/invoice';
import numberWithCommas from 'utils/numberWithCommas';

interface Props {
    item: ITableHeadCell;
    rowData: InvoiceResponseViewModel;
}

export const InvoiceListCell = ({ rowData: data, item }: Props) => {
    const field = data[item.field as keyof Omit<InvoiceResponseViewModel, 'attachments' | 'lineItems'>];

    if (item.field === 'isActive') {
        return <Typography variant="body2">{field ? 'active' : '--'}</Typography>;
    }

    if (item.field === 'total') {
        return <Typography variant="body2">${numberWithCommas(field as number)}</Typography>;
    }

    if (item.field === 'createdDate' || item.field === 'expirationDate') {
        return <Typography variant="body2">{getTransformedDate(field as string, 'MM/DD/YYYY') || '--'}</Typography>;
    }

    return (
        <Typography noWrap variant="body2">
            {field || '--'}
        </Typography>
    );
};
